import Footer from './Footer'
import LinkToDocusaurus from './LinkToDocusaurus'
import type { ComponentProps } from 'react'

interface Props {
  path: ComponentProps<typeof LinkToDocusaurus>['path']
}

/**
* Must reference a defined path to a Docusaurus page.
*/
const DocusaurusFooter = ({
  path
}: Props) => (
  <Footer>
    <span><LinkToDocusaurus path={path}>Learn more in the DAI documentation</LinkToDocusaurus></span>
  </Footer>
)

export default DocusaurusFooter
